class ComparisonProductsContent extends HTMLElement {
  constructor() {
    super();

    const comparisonProductImages = this.querySelectorAll('comparison-product-option-images');
    this.comparisonProductFeatures = this.querySelectorAll('.comparison-product-features');
    
    comparisonProductImages.forEach((comparisonProductImage) => {
      this.slide(comparisonProductImage);
    });

    this.comparisonProductFeatures.forEach((comparisonProductFeature) => {
      const featureCells = comparisonProductFeature.querySelectorAll('.comparison-product-feature-cell');
      featureCells.forEach((featureCell) => {
        featureCell.addEventListener('click', this.featureUpdate.bind(this));
      })
    })
  }

  slide(slide) {
    $(slide).slick({
      infinite: true,
      arrows: true,
      prevArrow: `<button class="slick-slide-arrow slick-slide-arrow-prev slick-slide-arrow-prev-template--19612109340984__main" data-type="prev" aria-label="Previous" role="button"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                    </path></svg>
                  </button>`,
      nextArrow: `<button class="slick-slide-arrow slick-slide-arrow-next slick-slide-arrow-next-template--19612109340984__main" data-type="next" aria-label="Next" role="button"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                  </path></svg>
                </button>`,
      dots: false
    });
  }

  featureUpdate(event) {
    const title = event.currentTarget.dataset.title;
    const content = event.currentTarget.dataset.content;
    const featureWrap = event.currentTarget.closest('.comparison-product-features');
    const featureCells = featureWrap.querySelectorAll('.comparison-product-feature-cell');
    const featureTitle = featureWrap.querySelector('.comparison-product-features-label h3');
    const featureContent = featureWrap.querySelector('.comparison-product-features-label div');

    featureCells.forEach((featureCell) => {
      featureCell.classList.remove('active');
    })
    event.currentTarget.classList.add('active');
    featureTitle.innerText = title;
    featureContent.innerText = content;
  }
}

customElements.define('comparison-products-content', ComparisonProductsContent);

class ComparisonProductColorOption extends ComparisonProductsContent {
  constructor() {
    super();

    this.colorOptions = this.querySelectorAll('.js-comparison-product-color-cell');
    this.formLabel = this.querySelector('.form__label span');

    this.colorOptions.forEach((colorOption) => {
      colorOption.addEventListener('click', this.colorView.bind(this));
    })
  }

  colorView(event) {
    const colorName = event.currentTarget.dataset.color;
    
    this.colorOptions.forEach((colorOption) => {
      colorOption.classList.remove('active');
    })
    event.currentTarget.classList.add('active');
    this.formLabel.innerText = colorName;

    this.updateMedia(colorName)
  }

  updateMedia(colorName) {
    const productId = this.dataset.productid;
    const mediaJson = JSON.parse(document.querySelector('#ProductMediaJSON-' + productId).innerHTML);
    const availableMedia = mediaJson.filter(element => element.alt == colorName);
    let mediaSlideContent = '';
    const mediaGallerySlide = document.querySelector(`.js-comparison-product-option-images[data-productid="${productId}"]`);

    if(availableMedia.length > 0){
      availableMedia.forEach((availableMediacell, index) => {
        const aspectRatio = 1 / availableMediacell.aspect_ratio * 100;

        const mediaSlideCell = `<div class="comparison-product-option-image-cell">
              <div class="media" style="padding-bottom: ${aspectRatio}%;">
                <img 
                  srcset="
                    ${getSizedImageUrl(availableMediacell.preview_image.src, '365x')},
                    ${getSizedImageUrl(availableMediacell.preview_image.src, '460x')},
                    ${getSizedImageUrl(availableMediacell.preview_image.src, '535x')}"
                  src="${getSizedImageUrl(availableMediacell.preview_image.src, '535x')}"
                  sizes="(min-width: 1200px) 550px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"
                  alt="${availableMediacell.alt}"
                  loading="lazy"
                  width="${availableMediacell.width}"
                  height="${availableMediacell.height}">
              </div>
            </div>`;
        mediaSlideContent += mediaSlideCell;
      })

      $(mediaGallerySlide).slick('unslick');
      mediaGallerySlide.innerHTML = mediaSlideContent;
      this.slide(mediaGallerySlide);
    }
  }
}

customElements.define('comparison-product-color-option', ComparisonProductColorOption);

class ComparisonContent extends HTMLElement {
  constructor() {
    super();

    const recentAddedItems = JSON.parse(window.localStorage.getItem('recentAddedItems'));
    const addedItemcount = Object.entries(recentAddedItems).length;

    this.contentUpdate(recentAddedItems, addedItemcount);
  }

  slide(slide) {
    $(slide).slick({
      infinite: true,
      arrows: true,
      prevArrow: `<button class="slick-slide-arrow slick-slide-arrow-prev slick-slide-arrow-prev-template--19612109340984__main" data-type="prev" aria-label="Previous" role="button"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                    </path></svg>
                  </button>`,
      nextArrow: `<button class="slick-slide-arrow slick-slide-arrow-next slick-slide-arrow-next-template--19612109340984__main" data-type="next" aria-label="Next" role="button"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                  </path></svg>
                </button>`,
      dots: false
    });
  }

  contentUpdate(recentAddedItems, addedItemcount) {
    // compare cells
    const compareProductImages = document.querySelector('[data-type="comparison-product-images"]');
    const compareProductTitles = document.querySelector('[data-type="comparison-product-titles"]');
    const compareProductPrices = document.querySelector('[data-type="comparison-product-prices"]');
    const compareProductQuickDetails = document.querySelector('[data-type="comparison-product-quick-details"]');
    const compareProductOptionColors = document.querySelector('[data-type="comparison-product-option-colors"]');
    const compareProductOptionSizes = document.querySelector('[data-type="comparison-product-option-sizes"]');
    const compareProductFits = document.querySelector('[data-type="comparison-product-fits"]');
    const compareProductRatings = document.querySelector('[data-type="comparison-product-ratings"]');
    const compareProductWaterproofings = document.querySelector('[data-type="comparison-product-waterproofings"]');
    const compareProductWarmth = document.querySelector('[data-type="comparison-product-warmth"]');
    const compareProductFeatures = document.querySelector('[data-type="comparison-product-features"]');
    const compareProductUpper = document.querySelector('[data-type="comparison-product-upper"]');
    const compareProductInsole = document.querySelector('[data-type="comparison-product-insole"]');
    const compareProductOutsole = document.querySelector('[data-type="comparison-product-outsole"]');
    const compareProductHeight = document.querySelector('[data-type="comparison-product-height"]');
    const compareProductWeight = document.querySelector('[data-type="comparison-product-weight"]');
    const compareProductLastTitle = document.querySelector('[data-type="comparison-product-last-title"]');
    const compareProductCTA = document.querySelector('[data-type="comparison-product-cta"]');
    const compareProductJsonModal = document.querySelector('[data-type="comparison-product-json-modal"]');
  
    if(addedItemcount > 0){
      for (const [key, value] of Object.entries(recentAddedItems)) {
        const productHandle = value.handle;

        fetch(`/products/${productHandle}?view=compare`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          //images
          const productImage = html.querySelector('.comparison-product-option-images-wrap');
          compareProductImages.insertAdjacentElement('beforeend', productImage);

          const productImageSlide = productImage.querySelector('comparison-product-option-images');
          this.slide(productImageSlide);

          //title
          const productTitle = html.querySelector('.js-compare-product-title');
          compareProductTitles.insertAdjacentElement('beforeend', productTitle);

          //price
          const productPrice = html.querySelector('.js-compare-product-price');
          compareProductPrices.insertAdjacentElement('beforeend', productPrice);

          //quick details
          const productQuickDetails = html.querySelector('.js-compare-product-quick-details');
          compareProductQuickDetails.insertAdjacentElement('beforeend', productQuickDetails);

          //option Colors
          const productOptionColors = html.querySelector('.js-compare-product-option-colors');
          compareProductOptionColors.insertAdjacentElement('beforeend', productOptionColors);

          //option sizes
          const productOptionSizes = html.querySelector('.js-compare-product-option-sizes');
          compareProductOptionSizes.insertAdjacentElement('beforeend', productOptionSizes);

          //fits
          const productFits = html.querySelector('.js-compare-product-fits');
          compareProductFits.insertAdjacentElement('beforeend', productFits);

          //ratings
          const productRatings = html.querySelector('.js-compare-product-ratings');
          compareProductRatings.insertAdjacentElement('beforeend', productRatings);

          //waterproofing
          const productWaterproofings = html.querySelector('.js-compare-water-proofing');
          compareProductWaterproofings.insertAdjacentElement('beforeend', productWaterproofings);

          //warmth
          const productWarmth = html.querySelector('.js-compare-product-warmth');
          compareProductWarmth.insertAdjacentElement('beforeend', productWarmth);

          //features
          const productFeatures = html.querySelector('.js-compare-product-features');
          compareProductFeatures.insertAdjacentElement('beforeend', productFeatures);

          //uppers
          const productUppers = html.querySelector('.js-compare-product-upper');
          compareProductUpper.insertAdjacentElement('beforeend', productUppers);

          //insole
          const productInsoles = html.querySelector('.js-compare-product-insole');
          compareProductInsole.insertAdjacentElement('beforeend', productInsoles);

          //outsole
          const productOutsoles = html.querySelector('.js-compare-product-outsole');
          compareProductOutsole.insertAdjacentElement('beforeend', productOutsoles);

          //height
          const productHeights = html.querySelector('.js-compare-product-height');
          compareProductHeight.insertAdjacentElement('beforeend', productHeights);

          //weight
          const productWeights = html.querySelector('.js-compare-product-weight');
          compareProductWeight.insertAdjacentElement('beforeend', productWeights);

          //last title
          const productLastTitles = html.querySelector('.js-compare-product-last-title');
          compareProductLastTitle.insertAdjacentElement('beforeend', productLastTitles);

          //last cta
          const productCTAs = html.querySelector('.js-compare-product-cta');
          compareProductCTA.insertAdjacentElement('beforeend', productCTAs);

          //json modal
          const productJsonModal = html.querySelector('.js-compare-product-json-modal');
          compareProductJsonModal.insertAdjacentElement('beforeend', productJsonModal);
        });
      }
    }
  }
}
customElements.define('comparison-content', ComparisonContent);